import { useCallback, useMemo, useState } from 'react';

export const useConfirmDialog = () => {
  const [confirmState, setConfirmState] = useState({ open: false });

  const showConfirmDialog = useCallback(
    async (props) => {
      return new Promise((resolve, reject) => {
        setConfirmState({
          open: true,
          onConfirm: () => {
            setConfirmState({ open: false });
            resolve();
          },
          onClose: () => {
            setConfirmState({ open: false });
            reject();
          },
          ...props,
        });
      });
    },
    [setConfirmState]
  );

  return useMemo(
    () => ({
      confirmDialogProps: confirmState,
      showConfirmDialog,
    }),
    [confirmState, showConfirmDialog]
  );
};
